module.exports = __webpack_public_path__ + "static/img/4.2006e7b6.jpg";